import { configureStore } from "@reduxjs/toolkit";
import currencyReducer from "./Slices/currencySlice";

const store = configureStore({
  reducer: {
    currency: currencyReducer,
  },
});

export default store;
